import {
  LoadingContainer,
  LegacyPage,
  Modal,
  Model,
  Panels,
  Bar,
  Input,
  NumericInput,
  DateInput,
  Select,
  Textarea,
  Form,
} from 'peach/components'
import { useParams } from 'peach/router'

import {
  useInternalDrawPurchasesGet,
  useInternalDrawPurchasesCreate,
} from 'core/types'

import { defaultPurchase } from './defaultPurchase'

const DrawPurchases = () => {
  const { companyId, personId, loanId, drawId } = useParams<{
    companyId?: string
    personId?: string
    loanId?: string
    drawId?: string
  }>()

  const {
    data: purchases,
    isLoading: isLoadingPurchases,
    error: purchasesError,
  } = useInternalDrawPurchasesGet({
    companyId,
    personId,
    loanId,
    drawId,
    options: { enabled: !!(companyId && personId && loanId && drawId) },
  })

  const { mutateAsync: createPurchaseMutate, isPending: isCreatingPurchase } =
    useInternalDrawPurchasesCreate({
      companyId,
      personId,
      loanId,
      drawId,
    })

  const sendCreatePurchase = async (formData) => {
    try {
      await createPurchaseMutate(formData)
    } catch (err) {
      console.error('Error creating purchase:', err)
    }
  }

  return (
    <Panels header={<Bar title='Purchases' />}>
      <Modal
        initialValue={defaultPurchase}
        onSubmit={sendCreatePurchase}
        title='Create Purchase'
      >
        <NumericInput formKey='amount' required />
        <DateInput formKey='purchaseDate' required />
        <Input formKey='externalId' />
        <Select formKey='type' options={['regular', 'refund', 'cashBack']} />
        <Select formKey='status' options={['settled', 'pending', 'canceled']} />
        <Form.Provider formKey='purchaseDetails' section>
          <Input
            formKey='description'
            note='The description of the purchase. Normally shown in Borrower Portal and on statements.'
          />
          <Select
            formKey='pointOfSaleType'
            options={['online', 'physical', 'recurring']}
          />
          <Input formKey='categoryId' />
          <Input formKey='externalCardId' />
          <Input formKey='merchantId' />
          <Input formKey='merchantName' />
          <NumericInput formKey='originalCurrencyAmount' />
          <Input
            formKey='originalCurrencyCode'
            note='The currency in which the purchase was made before currency conversion. Three letters according to ISO 4217.'
          />
          <NumericInput formKey='conversionRate' />
          <Textarea.Json formKey='metadata' />
        </Form.Provider>
        <Input
          fromKey='originalPurchaseId'
          note="Peach's unique or lender's external identifier."
        />
        <Textarea.Json formKey='metadata' />
      </Modal>
      <LoadingContainer
        error={purchasesError}
        isLoading={isLoadingPurchases || isCreatingPurchase}
      >
        <LegacyPage.Full>
          <Model.List json={purchases} />
        </LegacyPage.Full>
      </LoadingContainer>
    </Panels>
  )
}

export default DrawPurchases
